module.exports = __webpack_public_path__ + "static/media/jkyj.fbb3d66e.png";